// Las clases empiezan en punto o y media, pero siempre duran 60 minutos.
// Debe coincidir con _expand_half_hour_starts() del backend.
const toMinutes = (t) => {
  const [h, m] = t.split(':').map(Number);
  return h * 60 + m;
};

const toTime = (m) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;

/**
 * Añade los inicios a y media que caben enteros dentro de las horas abiertas:
 * con 09:00, 10:00 y 11:00 abiertas se puede empezar también a las 09:30 y 10:30,
 * pero nunca a las 11:30 (la clase terminaría fuera del horario abierto).
 */
export const expandHalfHourStarts = (slots = []) => {
  const base = [...new Set(slots.filter((t) => typeof t === 'string' && t.includes(':')).map(toMinutes))];
  const expanded = new Set(base);
  base.forEach((minute) => {
    if (base.includes(minute + 60)) expanded.add(minute + 30);
  });
  return [...expanded].sort((a, b) => a - b).map(toTime);
};
